export const categories = [
  {
    id: 'football',
    name: '足球',
    slug: 'football',
    icon: 'ri-football-line',
    description: '全球足球赛事资讯，涵盖五大联赛、欧冠、世界杯等顶级赛事的最新动态与深度分析',
    color: 'primary',
    articleCount: 128,
  },
  {
    id: 'basketball',
    name: '篮球',
    slug: 'basketball',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲篮球联赛等全球篮球赛事的第一手资讯与专业解读',
    color: 'accent',
    articleCount: 96,
  },
  {
    id: 'tennis',
    name: '网球',
    slug: 'tennis',
    icon: 'ri-base-station-line',
    description: '四大满贯、ATP、WTA巡回赛全程跟踪报道，网球爱好者的资讯首选',
    color: 'secondary',
    articleCount: 64,
  },
  {
    id: 'esports',
    name: '电竞',
    slug: 'esports',
    icon: 'ri-gamepad-line',
    description: '英雄联盟、DOTA2、CS2、王者荣耀等顶级电竞赛事的热血战报与深度分析',
    color: 'primary',
    articleCount: 156,
  },
  {
    id: 'comprehensive',
    name: '综合体育',
    slug: 'comprehensive',
    icon: 'ri-medal-line',
    description: '田径、游泳、乒乓球、羽毛球、F1等综合体育项目的全面报道与精彩瞬间',
    color: 'accent',
    articleCount: 82,
  },
];